// Acquisition attribution, read once from the URL at session start and stamped onto the
// consent record + every trace (see saveConsent / buildTrace). This is how we split
// "completed via the recruitment email" from "found it organically on nerdlegame.com".
//
//   ?src=<route>   coarse route tag. 'email' = the SES recruitment email; absent = organic
//                  (the www soft-promo). Free-form but sanitised + length-capped below.
//   ?t=<token>     per-user opaque token = HMAC(accountId, secret), minted by the
//                  recruitment script. Lets the daily brief compute conversion (emailed N →
//                  M completed) without putting any account id / PII in the research corpus:
//                  the token→account map lives only on the notifications side.
//
// Both are captured verbatim (sanitised) — the app never interprets them; they're pure
// provenance for downstream joins. Mirrors retroConfig's read-URL-param-once pattern.

export type SourceTag = {
  src: string | null // route, e.g. 'email' (null = organic / no param)
  token: string | null // per-user opaque invite token (null if none)
}

// Keep only URL-safe token/tag characters and cap length, so a tampered or junk param
// can't bloat a doc or smuggle anything through into BigQuery.
const clean = (v: string | null, max: number): string | null => {
  if (!v) return null
  const s = v.replace(/[^A-Za-z0-9._-]/g, '').slice(0, max)
  return s || null
}

export function getSourceTag(): SourceTag {
  try {
    const q = new URLSearchParams(window.location.search)
    return { src: clean(q.get('src'), 24), token: clean(q.get('t'), 64) }
  } catch {
    return { src: null, token: null }
  }
}
